import type {
  ApprovalLineInput,
  CreatePayloadApprover,
} from '@/utils/approval/approvalFormToCreatePayload';
import type {
  FlowEntry,
  FlowMemberData,
} from '@/components/Approval/ApprovalCreate/ApprovalLineSection';

/**
 * ApprovalLineSection의 UI flow → 저장 페이로드 입력.
 *
 * - 검색 슬롯(userId 미설정)은 결재자 미확정 상태이므로 제외.
 * - 협조결재 블록은 단일 contiguous 구간 가정 — flow 내 첫 cooperation 엔트리만 반영.
 *   현재 UI는 협조 블록 1개만 생성/유지하므로 단일 매칭과 일치.
 * - cooperation.insertIndex 는 flow에서 cooperation 블록 등장 직전까지 누적된 일반 결재자 수.
 */
const flowToApprovalLineInput = (
  flow: FlowEntry[],
  orderedCooperation: boolean,
): ApprovalLineInput => {
  const approvers: CreatePayloadApprover[] = [];
  let cooperation: ApprovalLineInput['cooperation'];

  flow.forEach((entry) => {
    if (entry.type === 'member') {
      if (entry.data.userId) {
        approvers.push({ passportId: entry.data.userId });
      }
    } else if (!cooperation) {
      const members = entry.members
        .filter((m): m is FlowMemberData & { userId: string } =>
          Boolean(m.userId),
        )
        .map((m) => ({ passportId: m.userId }));
      if (members.length > 0) {
        cooperation = {
          members,
          insertIndex: approvers.length,
          ordered: orderedCooperation,
        };
      }
    }
  });

  return cooperation ? { approvers, cooperation } : { approvers };
};

export default flowToApprovalLineInput;
